import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Softwares from './components/Softwares';
import SurveyMyStore from './components/SurveyMyStore';
import Terms from './components/Terms';
import Layout from './components/Layout';
import { logAnalyticsEvent, setAnalyticsScreen } from './firebase';

const App: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Log page view
    logAnalyticsEvent('page_view', {
      page_path: location.pathname + location.search,
      page_title: getPageTitle(location.pathname)
    });
    
    // Set current screen
    setAnalyticsScreen(getPageTitle(location.pathname));
  }, [location]);

  const getPageTitle = (path: string): string => {
    if (path === '/') return 'Home';
    if (path === '/softwares') return 'Software Solutions';
    if (path === '/softwares/surveymystore') return 'SurveyMyStore';
    if (path === '/softwares/surveymystore/terms') return 'SurveyMyStore Terms';
    return 'AE-Cloudsystem';
  };

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/softwares" element={<Softwares />} />
        <Route path="/softwares/surveymystore" element={<SurveyMyStore />} />
        <Route path="/softwares/surveymystore/terms" element={<Terms />} />
      </Routes>
    </Layout>
  );
};

export default App;


